import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {WordProvider} from "../../providers/word/word";

/**
 * Generated class for the MoodAnaComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'mood-ana',
  templateUrl: 'mood-ana.html'
})
export class MoodAnaComponent implements OnChanges{

  @Input() scope;
  @Input() choosedChatroom;

  constructor(public wordService:WordProvider) {
    console.log('Hello MoodAnaComponent Component');
  }

  ngOnChanges(changes:SimpleChanges){
    this.emoji_data = [];
    this.getEmojiData();
  }

  //情绪监控
  is_loading_emoji_data;
  is_error_emoji_data;
  emoji_data = [];

  total_count;
  emojiIcon = {
    'angry':{name:'愤怒',img:'./assets/imgs/angry.png'},
    'sad':{name:'悲伤',img:'./assets/imgs/sad.png'},
    'neg':{name:'厌恶',img:'./assets/imgs/neg.png'},
    'surprised':{name:'惊讶',img:'./assets/imgs/surprised.png'},
    'happy':{name:'高兴',img:'./assets/imgs/happy.png'},
    'like':{name:'喜欢',img:'./assets/imgs/like.png'},
  };
  emoji_option = this.wordService.getEmojiOption(this.emojiIcon);
  getEmojiData(){
    this.is_loading_emoji_data = true;
    this.is_error_emoji_data = false;
    this.wordService.getEmojiData(this.choosedChatroom?this.choosedChatroom.chatroomname:null,this.scope.value).subscribe(res => {
        this.is_loading_emoji_data = false;
        this.is_error_emoji_data = false;
        //TODO:main function
        this.emoji_data = res['content']['emotion_data'];
        this.total_count = res['content']['total_count'];
        this.emoji_option = this.wordService.getEmojiOption(this.emojiIcon,this.emoji_data,this.total_count);
      },
      err => {
        this.is_loading_emoji_data = false;
        this.is_error_emoji_data = true;
      })
  }
}



// WEBPACK FOOTER //
// ./src/components/mood-ana/mood-ana.ts